import { CONSENT_STORAGE_KEY, parseStoredConsent } from './analyticsCore';

let deniedInDocument = false;
export function setMeasurementDeniedInDocument(denied: boolean): void { deniedInDocument = denied; }

/** Denial-only hint: the browser can suppress measurement, never authorize it. */
export function hasMeasurementDenial(): boolean {
  if (deniedInDocument || typeof window === 'undefined') return true;
  try {
    return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true
      || parseStoredConsent(localStorage.getItem(CONSENT_STORAGE_KEY))?.decision === 'denied'
      || Object.keys(localStorage).some(key => key.split(':')[0] === 'lw_measurement_revocation_v1');
  } catch { return true; }
}
